import { createFileRoute } from "@tanstack/react-router";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";

export const Route = createFileRoute("/admin/analitica")({
  validateSearch: (search: Record<string, unknown>): { tab?: string | undefined } => ({
    tab: typeof search["tab"] === "string" ? (search["tab"] as string) : undefined,
  }),
  component: AdminAnalytics,
});
